import script from "./NavBarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__